<div class="location-chip-container">
	@for (location of displayedLocations(); track location.pk) {
		<mat-chip (click)="openLocationDialog()">
			<div class="location-chip">
				<mat-icon svgIcon="portfolio"> </mat-icon>
				{{ location.name }}
			</div>
		</mat-chip>
	}
</div>
